import { ImageAssetItem } from '@common/model/resource/image';
import { MediaType, assumeMediaTypeByFileUrl } from './mediaType';
import { isNextImage } from './nextImage';

type ResizedItem = { path: string; width: number; height: number };

const isAssetItem = (s: unknown): s is ImageAssetItem =>
  s instanceof ImageAssetItem ||
  (typeof s === 'object' && s !== null && s.hasOwnProperty('src') && s.hasOwnProperty('width') && s.hasOwnProperty('height'));

const isResizedItem = (s: unknown): s is ResizedItem =>
  typeof s === 'object' && s !== null && s.hasOwnProperty('width') && s.hasOwnProperty('height') && s.hasOwnProperty('path');

export const toResizedAssetItem = (source: unknown): ResizedItem => {
  if (typeof source === 'string') {
    return { path: source, width: 0, height: 0 };
  }
  if (isNextImage(source)) {
    return { path: source.src, width: source.width, height: source.height };
  }
  if (isResizedItem(source)) {
    return source;
  }
  return { path: '', width: 0, height: 0 };
};

/**
 * Coerce image in some formats to AssetItem
 */
export const toAssetItem = (...sources: unknown[]): ImageAssetItem => {
  let assetItem: ImageAssetItem = { src: '', width: 0, height: 0, mimeType: MediaType.unknown };
  const source = sources.shift();
  if (typeof source === 'string') {
    assetItem.src = source;
    assetItem.mimeType = assumeMediaTypeByFileUrl(source);
  } else if (isNextImage(source)) {
    assetItem = { ...source, mimeType: assumeMediaTypeByFileUrl(source.src) };
  } else if (isAssetItem(source)) {
    assetItem = { ...source };
  }

  for (const asset of sources) {
    if (!assetItem.images) {
      assetItem.images = [];
    }
    assetItem.images.push(toResizedAssetItem(asset));
  }

  return assetItem;
};
